import { Badge, LuIcon, Text } from "@overmap-ai/blocks"
import { type ProcedureStepEvent } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { procedureStepEventTypeData } from "../../mappings/procedures"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"

interface ProcedureStepEventActivityTimelineItemProps {
	procedureStepEvent: ProcedureStepEvent
}

export const ProcedureStepEventActivityTimelineItem = memo<ProcedureStepEventActivityTimelineItemProps>((props) => {
	const { procedureStepEvent } = props

	const createdBy = useAppSelector(selectUserById(procedureStepEvent.created_by ?? -1))
	const user = useAppSelector(selectUserById(procedureStepEvent.value ?? -1))
	const { icon, actionLabel, accentColor } = procedureStepEventTypeData[procedureStepEvent.type]
	const eventDate = procedureStepEvent.created_at ?? ""

	return (
		<div className="flex items-center gap-4">
			<Badge icon accentColor={accentColor} radius="full" variant="soft" size="xs">
				<LuIcon icon={icon} />
			</Badge>
			<Text accentColor="base" size="xs">
				<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
				&nbsp;{actionLabel}&nbsp;
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;&#8226;&nbsp;
				{formatCompactDate(eventDate)}
			</Text>
		</div>
	)
})
ProcedureStepEventActivityTimelineItem.displayName = "ProcedureStepEventActivityTimelineItem"
